

// import { useState, useEffect } from "react";
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Grid,
//   Box,
//   CircularProgress,
//   Alert,
//   ToggleButton,
//   ToggleButtonGroup,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Chip,
//   OutlinedInput,
//   FormHelperText,
// } from "@mui/material";
// import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { renderMultiSectionDigitalClockTimeView } from "@mui/x-date-pickers/timeViewRenderers";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import httpclient from "../../../Utils";
// import { useNotification } from "../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

// const AddDeliveryTruckScheduleDialog = ({
//   open,
//   handleClose,
//   refresh,
// }) => {
//   const [mode, setMode] = useState(null); // 'add' or 'select'
//   const [selectedTime, setSelectedTime] = useState(null);
//   const [groupName, setGroupName] = useState(""); // For add mode - new group name
//   const [selectedGroup, setSelectedGroup] = useState(""); // For select mode - selected group ID
//   const [selectedGroupName, setSelectedGroupName] = useState(""); // Store the selected group name
//   const [groupOptions, setGroupOptions] = useState([]); // Dropdown options
//   const [bayOptions, setBayOptions] = useState([]); // Bay dropdown options
//   const [selectedBays, setSelectedBays] = useState([]); // Multiple selected bay VALUES
//   const [loadingGroups, setLoadingGroups] = useState(false);
//   const [loadingBays, setLoadingBays] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();

//   // Fetch groups and bays when dialog opens
//   useEffect(() => {
//     if (open) {
//       fetchGroupsAndBays();
//     }
//   }, [open]);

//   // Reset form when dialog closes
//   useEffect(() => {
//     if (!open) {
//       // Reset all states when dialog closes
//       setMode(null);
//       setSelectedTime(null);
//       setGroupName("");
//       setSelectedGroup("");
//       setSelectedGroupName("");
//       setSelectedBays([]);
//       setGroupOptions([]);
//       setBayOptions([]);
//       setError("");
//     }
//   }, [open]);

//   const fetchGroupsAndBays = async () => {
//     setLoadingGroups(true);
//     setLoadingBays(true);
//     try {
//       const response = await httpclient.get("/delivery-truck-schedule");
      
//       if (response.data.status === 200) {
//         // Extract group_list from the response
//         const groupList = response.data.group_list || [];
//         setGroupOptions(groupList);
        
//         // Extract bay_list from the response
//         const bayList = response.data.bay_list || [];
//         setBayOptions(bayList);
        
//         console.log("Group options loaded:", groupList);
//         console.log("Bay options loaded:", bayList);
//       }
//     } catch (error) {
//       handleApiError(error);
//     } finally {
//       setLoadingGroups(false);
//       setLoadingBays(false);
//     }
//   };

//   const handleModeChange = (event, newMode) => {
//     if (newMode !== null) {
//       setMode(newMode);
//       // Reset only the mode-specific fields when switching modes
//       setGroupName("");
//       setSelectedGroup("");
//       setSelectedGroupName("");
//       setError("");
//     }
//   };

//   const handleGroupChange = (event) => {
//     const groupId = event.target.value;
//     setSelectedGroup(groupId);
    
//     // Find and store the group name
//     const selectedGroup = groupOptions.find(group => group.id === groupId);
//     if (selectedGroup) {
//       setSelectedGroupName(selectedGroup.group_name);
//     }
//     setError("");
//   };

//   const handleBayChange = (event) => {
//     const {
//       target: { value },
//     } = event;
    
//     // On autofill we get a stringified value
//     const selectedValues = typeof value === 'string' ? value.split(',') : value;
    
//     setSelectedBays(selectedValues);
//     setError(""); // Clear error when user selects bays
//   };

//   const handleDeleteBay = (bayValueToDelete) => {
//     setSelectedBays(selectedBays.filter(bayValue => bayValue !== bayValueToDelete));
//   };

//   const handleSubmit = async () => {
//     // Validation
//     if (!selectedTime) {
//       setError("Please select a time");
//       return;
//     }

//     if (mode === 'add' && !groupName.trim()) {
//       setError("Please enter a group name");
//       return;
//     }

//     if (mode === 'select' && !selectedGroup) {
//       setError("Please select a group");
//       return;
//     }

//     if (selectedBays.length === 0) {
//       setError("Please select at least one bay");
//       return;
//     }

//     setError("");
//     setLoading(true);

//     try {
//       // Format time in 24-hour format (e.g., 14:00 for 2pm)
//       const timeIn24HourFormat = dayjs(selectedTime).format("HH:mm");
      
//       // Prepare payload
//       let payload = {};
      
//       if (mode === 'add') {
//         payload = {
//           group_name: groupName.trim(),
//           time: timeIn24HourFormat,
//           bay: selectedBays, // Array of bay VALUES (e.g., ["SC", "S5"])
//         };
//       } else if (mode === 'select') {
//         payload = {
//           group_name: selectedGroupName,
//           time: timeIn24HourFormat,
//           bay: selectedBays, // Array of bay VALUES (e.g., ["SC", "S5"])
//           parent_id: selectedGroup, // Add parent_id for select mode
//         };
//       }

//       console.log("Payload being sent:", payload);
//       console.log("Mode:", mode);

//       const response = await httpclient.post("/delivery-truck-schedule/create", payload);

//       if (response.data.status === 200) {
//         showNotification("success", response.data.message);
//         handleClose();
//         refresh();
//       } else {
//         showNotification("info", response.data.message);
//       }
//     } catch (error) {
//       handleApiError(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     handleClose();
//   };

//   // Determine if submit button should be disabled
//   const isSubmitDisabled = () => {
//     if (loading) return true;
//     if (!mode) return true;
//     if (!selectedTime) return true;
//     if (selectedBays.length === 0) return true;
    
//     if (mode === 'add' && !groupName.trim()) return true;
//     if (mode === 'select' && !selectedGroup) return true;
    
//     return false;
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleCancel}
//       aria-labelledby="add-schedule-dialog-title"
//       maxWidth="sm"
//       fullWidth
//       keepMounted={false}
//     >
//       <DialogTitle id="add-schedule-dialog-title">
//         Delivery Truck Schedule
//       </DialogTitle>
//       <DialogContent>
//         {error && (
//           <Alert severity="error" sx={{ mt: 2, mb: 2 }} onClose={() => setError("")}>
//             {error}
//           </Alert>
//         )}

//         <Grid container spacing={3} sx={{ mt: 1 }}>
//           {/* Time Selection */}
//           <Grid item xs={12}>
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <TimePicker
//                 label="Select Time"
//                 value={selectedTime}
//                 onChange={(newValue) => {
//                   setSelectedTime(newValue);
//                   setError("");
//                 }}
//                 viewRenderers={{
//                   hours: renderMultiSectionDigitalClockTimeView,
//                   minutes: renderMultiSectionDigitalClockTimeView,
//                 }}
//                 slotProps={{
//                   textField: {
//                     fullWidth: true,
//                     size: "small",
//                     required: true,
//                   },
//                   layout: {
//                     sx: {
//                       '& .MuiDigitalClock-root': {
//                         width: '100%',
//                         maxHeight: '300px',
//                       },
//                     },
//                   },
//                 }}
//                 ampm={true}
//               />
//             </LocalizationProvider>
//           </Grid>

//           {/* Mode Selection Buttons */}
//           <Grid item xs={12}>
//             <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//               <ToggleButtonGroup
//                 value={mode}
//                 exclusive
//                 onChange={handleModeChange}
//                 aria-label="schedule mode"
//                 sx={{
//                   '& .MuiToggleButton-root': {
//                     px: 4,
//                     py: 1,
//                     '&.Mui-selected': {
//                       backgroundColor: '#7152F3',
//                       color: 'white',
//                       '&:hover': {
//                         backgroundColor: '#5c34fa',
//                       },
//                     },
//                   },
//                 }}
//               >
//                 <ToggleButton value="add" aria-label="add new">
//                   Add New
//                 </ToggleButton>
//                 <ToggleButton value="select" aria-label="select new">
//                   Select New
//                 </ToggleButton>
//               </ToggleButtonGroup>
//             </Box>
//           </Grid>

//           {/* Conditional Input Fields based on mode */}
//           {mode === 'add' && (
//             <Grid item xs={12}>
//               <TextField
//                 label="Add New Group Name"
//                 value={groupName}
//                 onChange={(e) => {
//                   setGroupName(e.target.value);
//                   setError("");
//                 }}
//                 fullWidth
//                 size="small"
//                 required
//                 placeholder="Enter new group name"
//                 helperText="Enter the name for the new group"
//               />
//             </Grid>
//           )}

//           {mode === 'select' && (
//             <Grid item xs={12}>
//               <FormControl fullWidth size="small" required>
//                 <InputLabel id="group-select-label">Select New Group</InputLabel>
//                 <Select
//                   labelId="group-select-label"
//                   id="group-select"
//                   value={selectedGroup}
//                   label="Select New Group"
//                   onChange={handleGroupChange}
//                   disabled={loadingGroups}
//                 >
//                   {loadingGroups ? (
//                     <MenuItem disabled>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <CircularProgress size={20} /> Loading groups...
//                       </Box>
//                     </MenuItem>
//                   ) : groupOptions.length > 0 ? (
//                     groupOptions.map((group) => (
//                       <MenuItem key={group.id} value={group.id}>
//                         {group.group_name} 
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem disabled>No groups available</MenuItem>
//                   )}
//                 </Select>
//                 <FormHelperText>Select an existing group</FormHelperText>
//               </FormControl>
//             </Grid>
//           )}

//           {/* Bay Selection - Multiple Select with Chips */}
//           <Grid item xs={12}>
//             <FormControl fullWidth size="small" required>
//               <InputLabel id="bay-multiple-chip-label">Pulling Bay</InputLabel>
//               <Select
//                 labelId="bay-multiple-chip-label"
//                 id="bay-multiple-chip"
//                 multiple
//                 value={selectedBays}
//                 onChange={handleBayChange}
//                 input={<OutlinedInput id="select-multiple-chip" label="Pulling Bay" />}
//                 renderValue={(selected) => (
//                   <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                     {selected.map((value) => (
//                       <Chip 
//                         key={value} 
//                         label={value} 
//                         size="small"
//                         onDelete={() => handleDeleteBay(value)}
//                         onMouseDown={(e) => e.stopPropagation()}
//                       />
//                     ))}
//                   </Box>
//                 )}
//                 MenuProps={MenuProps}
//                 disabled={loadingBays}
//               >
//                 {loadingBays ? (
//                   <MenuItem disabled>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <CircularProgress size={20} /> Loading bays...
//                     </Box>
//                   </MenuItem>
//                 ) : bayOptions.length > 0 ? (
//                   bayOptions.map((bay) => (
//                     <MenuItem key={bay.id} value={bay.bay}> {/* Using bay.bay as value */}
//                       {bay.bay}
//                     </MenuItem>
//                   ))
//                 ) : (
//                   <MenuItem disabled>No bays available</MenuItem>
//                 )}
//               </Select>
//               <FormHelperText>You can select multiple bays</FormHelperText>
//             </FormControl>
//           </Grid>

//           {/* Mode-specific helper text */}
//           {mode && (
//             <Grid item xs={12}>
//               <Alert severity="info" sx={{ mt: 1 }}>
//                 {mode === 'add' 
//                   ? "You are about to add a new delivery truck schedule. Please enter the new group name, select time, and choose at least one bay."
//                   : `You are about to add a new schedule for an existing group.`}
//               </Alert>
//             </Grid>
//           )}
//         </Grid>
//       </DialogContent>
//       <DialogActions sx={{ mb: 2, mr: 2, mt: 2 }}>
//         <Button
//           variant="outlined"
//           onClick={handleCancel}
//           color="primary"
//           disabled={loading}
//         >
//           Cancel
//         </Button>
//         <Button
//           variant="contained"
//           onClick={handleSubmit}
//           disabled={isSubmitDisabled()}
//           sx={{
//             backgroundColor: "#7152F3",
//             "&:hover": { backgroundColor: "#5c34fa" },
//             minWidth: "100px",
//           }}
//         >
//           {loading ? (
//             <>
//               <CircularProgress size={20} sx={{ mr: 1 }} color="inherit" />
//               Saving...
//             </>
//           ) : (
//             "Add Schedule"
//           )}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AddDeliveryTruckScheduleDialog;

// ********************************************************************************************

import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  Box,
  CircularProgress,
  Alert,
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderMultiSectionDigitalClockTimeView } from "@mui/x-date-pickers/timeViewRenderers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import httpclient from "../../../Utils";
import { useNotification } from "../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";

const AddDeliveryTruckScheduleDialog = ({
  open,
  handleClose,
  refresh,
}) => {
  const [mode, setMode] = useState(null); // 'add' or 'select'
  const [selectedTime, setSelectedTime] = useState(null);
  const [groupName, setGroupName] = useState(""); // For add mode - new group name
  const [selectedGroup, setSelectedGroup] = useState(""); // For select mode - selected group ID
  const [selectedGroupName, setSelectedGroupName] = useState(""); // Store the selected group name
  const [groupOptions, setGroupOptions] = useState([]); // Dropdown options
  const [bayOptions, setBayOptions] = useState([]); // Bay dropdown options
  const [selectedBays, setSelectedBays] = useState([]); // Multiple selected bay objects
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [loadingBays, setLoadingBays] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  // State for autocomplete
  const [inputValue, setInputValue] = useState("");

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();

  // Fetch groups and bays when dialog opens
  useEffect(() => {
    if (open) {
      fetchGroupsAndBays();
    }
  }, [open]);

  // Reset form when dialog closes
  useEffect(() => {
    if (!open) {
      // Reset all states when dialog closes
      setMode(null);
      setSelectedTime(null);
      setGroupName("");
      setSelectedGroup("");
      setSelectedGroupName("");
      setSelectedBays([]);
      setGroupOptions([]);
      setBayOptions([]);
      setError("");
      setInputValue("");
    }
  }, [open]);

  const fetchGroupsAndBays = async () => {
    setLoadingGroups(true);
    setLoadingBays(true);
    try {
      const response = await httpclient.get("/delivery-truck-schedule");
      
      if (response.data.status === 200) {
        // Extract group_list from the response
        const groupList = response.data.group_list || [];
        setGroupOptions(groupList);
        
        // Extract bay_list from the response
        const bayList = response.data.bay_list || [];
        setBayOptions(bayList);
        
        console.log("Group options loaded:", groupList);
        console.log("Bay options loaded:", bayList);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoadingGroups(false);
      setLoadingBays(false);
    }
  };

  const handleModeChange = (event, newMode) => {
    if (newMode !== null) {
      setMode(newMode);
      // Reset only the mode-specific fields when switching modes
      setGroupName("");
      setSelectedGroup("");
      setSelectedGroupName("");
      setError("");
    }
  };

  const handleGroupChange = (event) => {
    const groupId = event.target.value;
    setSelectedGroup(groupId);
    
    // Find and store the group name
    const selectedGroup = groupOptions.find(group => group.id === groupId);
    if (selectedGroup) {
      setSelectedGroupName(selectedGroup.group_name);
    }
    setError("");
  };

  const handleDeleteBay = (bayValueToDelete) => {
    setSelectedBays(selectedBays.filter(bay => bay.bay !== bayValueToDelete));
  };

  const handleSubmit = async () => {
    // Validation
    if (!selectedTime) {
      setError("Please select a time");
      return;
    }

    if (mode === 'add' && !groupName.trim()) {
      setError("Please enter a group name");
      return;
    }

    if (mode === 'select' && !selectedGroup) {
      setError("Please select a group");
      return;
    }

    if (selectedBays.length === 0) {
      setError("Please select at least one bay");
      return;
    }

    setError("");
    setLoading(true);

    try {
      // Format time in 24-hour format (e.g., 14:00 for 2pm)
      const timeIn24HourFormat = dayjs(selectedTime).format("HH:mm");
      
      // Extract bay values for payload
      const bayValues = selectedBays.map(bay => bay.bay);
      
      // Prepare payload
      let payload = {};
      
      if (mode === 'add') {
        payload = {
          group_name: groupName.trim(),
          time: timeIn24HourFormat,
          bay: bayValues, // Array of bay VALUES (e.g., ["SC", "S5"])
        };
      } else if (mode === 'select') {
        payload = {
          group_name: selectedGroupName,
          time: timeIn24HourFormat,
          bay: bayValues, // Array of bay VALUES (e.g., ["SC", "S5"])
          parent_id: selectedGroup, // Add parent_id for select mode
        };
      }

      console.log("Payload being sent:", payload);
      console.log("Mode:", mode);

      const response = await httpclient.post("/delivery-truck-schedule/create", payload);

      if (response.data.status === 200) {
        showNotification("success", response.data.message);
        handleClose();
        refresh();
      } else {
        showNotification("info", response.data.message);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    handleClose();
  };

  // Determine if submit button should be disabled
  const isSubmitDisabled = () => {
    if (loading) return true;
    if (!mode) return true;
    if (!selectedTime) return true;
    if (selectedBays.length === 0) return true;
    
    if (mode === 'add' && !groupName.trim()) return true;
    if (mode === 'select' && !selectedGroup) return true;
    
    return false;
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="add-schedule-dialog-title"
      maxWidth="sm"
      fullWidth
      keepMounted={false}
    >
      <DialogTitle id="add-schedule-dialog-title">
        Delivery Truck Schedule
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mt: 2, mb: 2 }} onClose={() => setError("")}>
            {error}
          </Alert>
        )}

        <Grid container spacing={3} sx={{ mt: 1 }}>
          {/* Time Selection */}
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Select Time"
                value={selectedTime}
                onChange={(newValue) => {
                  setSelectedTime(newValue);
                  setError("");
                }}
                viewRenderers={{
                  hours: renderMultiSectionDigitalClockTimeView,
                  minutes: renderMultiSectionDigitalClockTimeView,
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    required: true,
                  },
                  layout: {
                    sx: {
                      '& .MuiDigitalClock-root': {
                        width: '100%',
                        maxHeight: '300px',
                      },
                    },
                  },
                }}
                ampm={true}
              />
            </LocalizationProvider>
          </Grid>

          {/* Mode Selection Buttons */}
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <ToggleButtonGroup
                value={mode}
                exclusive
                onChange={handleModeChange}
                aria-label="schedule mode"
                sx={{
                  '& .MuiToggleButton-root': {
                    px: 4,
                    py: 1,
                    '&.Mui-selected': {
                      backgroundColor: '#7152F3',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#5c34fa',
                      },
                    },
                  },
                }}
              >
                <ToggleButton value="add" aria-label="add new">
                  Add New
                </ToggleButton>
                <ToggleButton value="select" aria-label="select new">
                  Select New
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Grid>

          {/* Conditional Input Fields based on mode */}
          {mode === 'add' && (
            <Grid item xs={12}>
              <TextField
                label="Add New Group Name"
                value={groupName}
                onChange={(e) => {
                  setGroupName(e.target.value);
                  setError("");
                }}
                fullWidth
                size="small"
                required
                placeholder="Enter new group name"
                helperText="Enter the name for the new group"
              />
            </Grid>
          )}

          {mode === 'select' && (
            <Grid item xs={12}>
              <FormControl fullWidth size="small" required>
                <InputLabel id="group-select-label">Select New Group</InputLabel>
                <Select
                  labelId="group-select-label"
                  id="group-select"
                  value={selectedGroup}
                  label="Select New Group"
                  onChange={handleGroupChange}
                  disabled={loadingGroups}
                >
                  {loadingGroups ? (
                    <MenuItem disabled>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={20} /> Loading groups...
                      </Box>
                    </MenuItem>
                  ) : groupOptions.length > 0 ? (
                    groupOptions.map((group) => (
                      <MenuItem key={group.id} value={group.id}>
                        {group.group_name} 
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No groups available</MenuItem>
                  )}
                </Select>
                <FormHelperText>Select an existing group</FormHelperText>
              </FormControl>
            </Grid>
          )}

          {/* Bay Selection - Autocomplete with built-in search */}
          <Grid item xs={12}>
            <Autocomplete
              multiple
              id="bay-autocomplete"
              options={bayOptions}
              loading={loadingBays}
              value={selectedBays}
              onChange={(event, newValue) => {
                setSelectedBays(newValue);
                setError("");
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              getOptionLabel={(option) => option.bay}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pulling Bay"
                  placeholder="Type to search and select bays"
                  size="small"
                  required
                  error={selectedBays.length === 0 && !!error}
                  helperText={selectedBays.length === 0 && error ? "Please select at least one bay" : "Type to search, select multiple bays"}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingBays ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              renderTags={() => null} // Don't render tags inside the input
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontWeight: selected ? 600 : 400 }}>
                  {option.bay}
                </li>
              )}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              disabled={loadingBays}
              filterOptions={(options, { inputValue }) => {
                const filter = options.filter(option =>
                  option.bay.toLowerCase().includes(inputValue.toLowerCase())
                );
                return filter;
              }}
              noOptionsText="No bays found"
              openOnFocus
              autoHighlight
            />
            
            {/* Display selected chips below the autocomplete */}
            {selectedBays.length > 0 && (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                {selectedBays.map((bay) => (
                  <Chip
                    key={bay.id}
                    label={bay.bay}
                    size="small"
                    onDelete={() => handleDeleteBay(bay.bay)}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            )}
          </Grid>

          {/* Mode-specific helper text */}
          {mode && (
            <Grid item xs={12}>
              <Alert severity="info" sx={{ mt: 1 }}>
                {mode === 'add' 
                  ? "You are about to add a new delivery truck schedule. Please enter the new group name, select time, and choose at least one bay."
                  : `You are about to add a new schedule for an existing group.`}
              </Alert>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ mb: 2, mr: 2, mt: 2 }}>
        <Button
          variant="outlined"
          onClick={handleCancel}
          color="primary"
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={isSubmitDisabled()}
          sx={{
            backgroundColor: "#7152F3",
            "&:hover": { backgroundColor: "#5c34fa" },
            minWidth: "100px",
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1 }} color="inherit" />
              Saving...
            </>
          ) : (
            "Add Schedule"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDeliveryTruckScheduleDialog;